<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" type="primary" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit" :disabled="!tableSelectedRows || tableSelectedRows.length !== 1">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel" :disabled="!tableSelectedRows || tableSelectedRows.length === 0">删除</a-button>
				<a-button icon="sync" @click="apiStaffCardQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="通行卡查询">
				<div class="qinang-search-row">
                    <div class="qinang-search-col-3">
						<div class="qinang-search-col-title" style="width: 120px;">服务商：</div>
						<a-select v-model="query.facilitatorId" show-search option-filter-prop="children" :filter-option="filterOption" style="width: 100%;" placeholder="请选择服务商" allowClear>
							<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
                    <div class="qinang-search-col-3">
						<div class="qinang-search-col-title" style="width: 120px;">卡类型：</div>
						<a-select v-model="query.staffCardType" show-search  style="width: 100%;" placeholder="请选择卡类型" allowClear>
							<a-select-option v-for="(item,index) in cardTypeList" :value="item.value" :key="index">{{item.label}}</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div  class="qinang-search-col-title" style="width: 120px;">卡号：</div>
						<a-input v-model="query.cardCode" style="width: 100%;" placeholder="请输入卡号" />
					</div>
				</div>
                <div class="qinang-search-row" style="margin-top: 10px;">
					<div class="qinang-search-col-3">
						<div  class="qinang-search-col-title" style="width: 120px;">通行卡名称：</div>
						<a-input v-model="query.staffName" style="width: 100%;" placeholder="请输入通行卡名称" />
					</div>
                    <div class="qinang-search-col-3">
                        <div  class="qinang-search-col-title" style="width: 100%;">
                            <a-button type="primary" icon="search" @click="apiStaffCardQueryList">查询</a-button>
                        </div>
                    </div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						通行卡列表
					</a-breadcrumb-item>
				</a-breadcrumb>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="printTemplateId" :loading="tableLoading" :pagination="false">
                
                <span slot="staffName" slot-scope="staffName">
                    <a-button type="link" @click="edit(staffName)" >{{staffName.staffName}}</a-button>
				</span>
                <span slot="staffCardType" slot-scope="staffCardType">
					{{ staffCardType.staffCardType == 'qr'?'虚拟卡':'实体卡' }}
				</span>
                <span slot="staffCardCode" slot-scope="staffCardCode">
					{{ staffCardCode.staffCardType == 'qr'?staffCardCode.virtualCard:staffCardCode.physicalCard }}
				</span>
                <span slot="staffCardTime" slot-scope="staffCardTime">
					{{qaUtil.parseTime(staffCardTime.startTime,'{y}年{m}月{d}日')+' 至 '+ qaUtil.parseTime(staffCardTime.endTime,'{y}年{m}月{d}日')}}
				</span>
                
                <span slot="staffCardState" slot-scope="staffCardState">
                    <span v-if="staffCardState.staffCardState == 2">禁用</span>
                    <span v-if="staffCardState.staffCardState == 3">启用</span>
				</span>

                <span slot="createTime" slot-scope="createTime">
					{{qaUtil.timeFormat(createTime.createTime)}}
				</span>
            
            </a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->
		<a-modal class="qa-modal-hf" title="添加" width="600px" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false" >
			<a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 20}" :rules="addRules">
				<a-form-model-item label="通行卡名称" has-feedback prop="staffName">
					<a-input v-model="addForm.staffName" placeholder="请输入通行卡名称" />
				</a-form-model-item>
                <a-form-model-item label="卡类型" has-feedback prop="staffCardType">
					<a-radio-group name="staffCardType" v-model="addForm.staffCardType">
						<a-radio v-for="item in cardTypeList" :value="item.value">{{item.label}}</a-radio>
					</a-radio-group>
				</a-form-model-item>
                <a-form-model-item v-if="addForm.staffCardType == 'qr'" label="虚拟卡号" has-feedback prop="virtualCard">
					<a-input  v-model="addForm.virtualCard" placeholder="请输入虚拟卡号" />
				</a-form-model-item>
                <a-form-model-item v-else label="实体卡号" has-feedback prop="physicalCard">
					<a-input v-model="addForm.physicalCard" placeholder="请输入实体卡号" />
				</a-form-model-item>
                <a-form-model-item label="生效日期" has-feedback prop="startTime" @change="">
                    <a-date-picker v-model="addForm.startTime" format="YYYY-MM-DD"/>
                </a-form-model-item>
                <a-form-model-item label="失效日期" has-feedback prop="endTime">
                    <a-date-picker v-model="addForm.endTime" format="YYYY-MM-DD"/>
                </a-form-model-item>

				<a-form-model-item label="服务商" has-feedback prop="facilitatorIds">
					<a-select mode="multiple" v-model="addForm.facilitatorIds" show-search option-filter-prop="children" :filter-option="filterOption" placeholder="请选择服务商">
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="用户" has-feedback prop="touristId">
					<a-select v-model="addForm.touristId" show-search :filter-option="false"
						@search="handleSearchTourist" placeholder="请输入姓名搜索用户" allowClear>
						<a-select-option v-for="item in touristList" :key="item.touristId" :value="item.touristId">{{
							item.realName }}</a-select-option>
					</a-select>
				</a-form-model-item>
                <a-form-model-item label="备注" has-feedback prop="remark">
					<a-input v-model="addForm.remark" placeholder="请输入备注，非必填项" />
				</a-form-model-item>
                <a-form-model-item label="是否启用" has-feedback prop="staffCardState">
					<a-radio-group name="staffCardState" v-model="addForm.staffCardState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 修改弹窗 -->
		<a-modal class="qa-modal-hf" title="修改" width="600px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false" >
			<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="通行卡名称" has-feedback prop="staffName">
					<a-input v-model="editForm.staffName" placeholder="请输入通行卡名称" />
				</a-form-model-item>
                <a-form-model-item label="卡类型" has-feedback prop="staffCardType">
					<a-radio-group name="staffCardType" v-model="editForm.staffCardType">
						<a-radio v-for="item in cardTypeList" :value="item.value">{{item.label}}</a-radio>
					</a-radio-group>
				</a-form-model-item>
                <a-form-model-item v-if="editForm.staffCardType == 'qr'" label="虚拟卡号" has-feedback prop="virtualCard">
					<a-input  v-model="editForm.virtualCard" placeholder="请输入虚拟卡号" />
				</a-form-model-item>
                <a-form-model-item v-else label="实体卡号" has-feedback prop="physicalCard">
					<a-input v-model="editForm.physicalCard" placeholder="请输入实体卡号" />
				</a-form-model-item>
                <a-form-model-item label="生效日期" has-feedback prop="startTime">
                    <a-date-picker v-model="editForm.startTime" format="YYYY-MM-DD"/>
                </a-form-model-item>
                <a-form-model-item label="失效日期" has-feedback prop="endTime">
                    <a-date-picker v-model="editForm.endTime" format="YYYY-MM-DD"/>
                </a-form-model-item>
				<a-form-model-item label="服务商" has-feedback prop="facilitatorIds">
					<a-select mode="multiple" v-model="editForm.facilitatorIds" show-search option-filter-prop="children" :filter-option="filterOption" placeholder="请选择服务商">
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="用户" has-feedback prop="touristId">
					<a-select v-model="editForm.touristId" show-search :filter-option="false"
						@search="handleSearchTourist" @change="onTouristChange" placeholder="请输入姓名搜索用户" allowClear>
						<a-select-option v-for="item in touristList" :key="item.touristId" :value="item.touristId">{{
							item.realName }}</a-select-option>
					</a-select>
				</a-form-model-item>
                <a-form-model-item label="备注" has-feedback prop="remark">
					<a-input v-model="editForm.remark" placeholder="请输入备注，非必填项" />
				</a-form-model-item>
                <a-form-model-item label="是否启用" has-feedback prop="staffCardState">
					<a-radio-group name="staffCardState" v-model="editForm.staffCardState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				// 打印参数
				paramOptions: [],
                //服务商列表
				facilitatorList: [],
                //卡类型
                cardTypeList:[
                    {
                        label:"虚拟卡",
                        value:"qr"
                    },
                    {
                        label:"实体卡",
                        value:"card"
                    }
                ],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					staffCardType: undefined,
					staffName: undefined,
                    facilitatorId: undefined,
                    cardCode: undefined,
				},
				tableData: [],
				tableColumns: [
                    { title:'ID', dataIndex:'staffCardId', key:'staffCardId', align:'center',width:'100'},
					{ 
                        title:'通行卡名称', 
                        key:'staffName', 
                        align:'center',
                        width:'150',
                        scopedSlots: {
							customRender: 'staffName'
						}
                    },
                    { 
                        title:'卡类型', 
                        key:'staffCardType', 
                        align:'center',
                        width:'100',
                        scopedSlots: {
							customRender: 'staffCardType'
						}
                    },
                    { 
                        title:'卡号', 
                        key:'staffCardCode', 
                        align:'center',
                        width:'200',
                        scopedSlots: {
							customRender: 'staffCardCode'
						}
                    },
                    { 
                        title:'有效期', 
                        key:'staffCardTime', 
                        align:'center',
                        width:'100',
                        scopedSlots: {
							customRender: 'staffCardTime'
						}
                    },
                    { 
                        title:'启用状态', 
                        key:'staffCardState', 
                        align:'center',
                        width:'100',
                        scopedSlots: {
							customRender: 'staffCardState'
						}
                    },
					{ 
                        title:'创建时间',
                        key:'createTime', 
                        align:'center',
                        scopedSlots: {
							customRender: 'createTime'
						}
                    },
				],
				tableLoading: false,
				tableSelectedRows: [],
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					staffName: undefined,
					staffCardType: 'card',
                    virtualCard: undefined,
                    physicalCard: undefined,
                    startTime: '',
                    endTime: '',
                    facilitatorIds: [],
                    facilitatorId: '',
                    remark: '',
                    staffCardState: 3,
					touristId: undefined,  // 新增
				},
				addRules: {
					staffName: [{ required: true, message: '通行卡名称不能为空', trigger: 'blur' }],
					facilitatorIds: [{ required: true, message: '请选择服务商', trigger: 'change' }],
                    virtualCard: [{ required: true, message: '虚拟卡号不能为空', trigger: 'blur' }],
                    physicalCard: [{ required: true, message: '实体卡号不能为空', trigger: 'blur' }],
                    startTime: [{ required: true, message: '生效日期不能为空', trigger: 'blur' }],
                    endTime: [{ required: true, message: '失效日期不能为空', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
                    staffCardId: '',
					staffName: undefined,
					staffCardType: 'card',
                    virtualCard: undefined,
                    physicalCard: undefined,
                    startTime: '',
                    endTime: '',
                    facilitatorIds: [],
                    facilitatorId: '',
                    remark: '',
                    staffCardState: 3,
					touristId: undefined,  
					_originTouristId: 0,   // 用于保存原始用户ID
				},
				// 修改弹窗-end
				touristList: [],          // 用户下拉列表
				touristTouched: false,    // 修改时标记用户是否手动操作过
				searchTimer: null,        // 防抖计时器
		
			};
		},
		methods: {
            //获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList, {staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
				} else {
					this.$message.error(res.msg)
				}
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			//--------------表格开始-搜索
			async apiStaffCardQueryList() {
				this.tableLoading = true
                if(this.query.staffCardType == 'qr' && this.query.cardCode != undefined){
                    this.query.virtualCard = this.query.cardCode
                    
                } else if(this.query.staffCardType == 'card' && this.query.cardCode != undefined){
                    this.query.physicalCard = this.query.cardCode
                } else{
                    this.query.cardCode = undefined
                }
				const { data: res } = await this.$http.post(this.navigation.apiStaffCardQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiStaffCardQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiStaffCardQueryList()
			},
			handleCancel() {
				this.addVisible = false
				this.editVisible = false
			},

			// 添加
			tableAdd() {
				this.touristList = []
				this.touristTouched = false
				this.addVisible = true
				this.addConfirmLoading = false
				this.addForm = {
					staffName: undefined,
					staffCardType: 'card',
                    virtualCard: undefined,
                    physicalCard: undefined,
                    startTime: '',
                    endTime: '',
                    facilitatorId: [],
                    remark: '',
                    staffCardState: 3,
					touristId: undefined,  // 新增
				}
				if(this.$refs.addRuleForm) {
					this.$refs.addRuleForm.resetFields();
				}
			},

			async apiStaffCardAdd() {
                this.addForm.facilitatorId = JSON.stringify(this.addForm.facilitatorIds);
				this.addConfirmLoading = true
				const params = { ...this.addForm }
				params.touristId = params.touristId || 0
                const { data: res } = await this.$http.post(this.navigation.apiStaffCardAdd, params);
                if (res.code == 200) {
                    this.$message.success(res.msg)
                    if(this.$refs.addRuleForm) {
                        this.$refs.addRuleForm.resetFields();
                    }
                    this.addConfirmLoading = false
                    this.addVisible = false
                    this.apiStaffCardQueryList()
                } else {
                    this.$message.error(res.msg)
                    this.addConfirmLoading = false
                }
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiStaffCardAdd()
					} else {
						return false;
					}
				});
			},

			// 修改
			async edit(item){
				this.editConfirmLoading = false
				this.editVisible = true
				// ========== 处理用户预填充和标记 ==========
				this.touristTouched = false
				this.editForm = item
                this.editForm.facilitatorIds = JSON.parse(item.facilitatorId)
				this.editForm.touristId = this.editForm.touristId ? this.editForm.touristId : undefined
				this.editForm._originTouristId = this.editForm.touristId || 0
				// 预填充用户选项
				this.touristList = []
				if (this.editForm.touristId && item.realName) {
					this.touristList = [{
						touristId: this.editForm.touristId,
						realName: item.realName
					}]
				} else if (this.editForm.touristId) {
		
					this.$http.post(this.navigation.apiPromotionUserQueryList, {
						page: 1,
						size: 1,
						touristId: this.editForm.touristId
					}).then(({ data: res }) => {
						if (res.code == 200 && res.data.list && res.data.list.length) {
							this.touristList = res.data.list
						}
					})
				}
			},
			async apiStaffCardEdit() {
				this.editConfirmLoading = true
                this.editForm.facilitatorId = JSON.stringify(this.editForm.facilitatorIds);

				const params = { ...this.editForm }
				if (!this.touristTouched) {
					params.touristId = this.editForm._originTouristId
				} else {
					params.touristId = params.touristId || 0
				}
				delete params._originTouristId
                const { data: res } = await this.$http.post(this.navigation.apiStaffCardEdit, params);
                if (res.code == 200) {
                    this.$message.success(res.msg)
                    this.editConfirmLoading = false
                    this.editVisible = false
                    this.apiStaffCardQueryList()
                } else {
                    this.$message.error(res.msg)
                    this.editConfirmLoading = false
                }
		
			},
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiStaffCardEdit()
					} else {
						return false;
					}
				});
			},
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.length > 0) {
					const ids = this.tableSelectedRows.map(row=>row.staffCardId)
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: '当前选中' + ids.length + '条数据。',
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiStaffCardDel(ids)
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiStaffCardDel(ids) {
				const { data: res } = await this.$http.post(this.navigation.apiStaffCardDel + '/'+ ids);
				if (res.code == 200) {
					this.$message.success(res.msg)
					await this.apiStaffCardQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				if(this.tableSelectedRows.length === 1) {
					const item = this.tableData.find(item => item.printTemplateId == this.tableSelectedRows[0].printTemplateId)
					this.edit(item)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},

			handleSearchTourist(keyword) {
				clearTimeout(this.searchTimer)
				if (!keyword || !keyword.trim()) {
					this.touristList = []
					return
				}
				this.searchTimer = setTimeout(() => {
					this.$http.post(this.navigation.apiPromotionUserQueryList, {
						page: 1,
						size: 20,
						realName: keyword.trim()
					}).then(({ data: res }) => {
						if (res.code == 200) {
							this.touristList = res.data.list || []
						} else {
							this.$message.error(res.msg)
						}
					})
				}, 300)
			},
			onTouristChange() {
				this.touristTouched = true
			},
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows;
					},
				};
			},
		},
		created() {
            this.apiFacilitatorList()
			this.apiStaffCardQueryList()
		}
	};
</script>

<style scoped>
.param-list {
	display: flex;
	flex-direction: column;
	max-height: calc(100vh - 350px);
	overflow: auto;
	padding: 8px;
	background: #fafafa;
	border: 1px solid #e8e8e8;
	border-radius: 4px;
}
.param-row {
	display: flex;
	align-items: center;
	margin-bottom: 8px;
}
.param-header {
	display: flex;
	align-items: center;
	font-weight: 600;
	margin-bottom: 8px;
}
.col-select {
	width: 80px;
	display: flex;
	align-items: center;
}
.col-title {
	width: 160px;
	text-align: center;
	margin-left: 12px;
}
.col-input {
	background-color: #fff !important;
	color: rgba(0, 0, 0, 0.65) !important;
	width: 160px;
	margin-left: 12px;
}
.qa-modal ::v-deep .ant-form{
	overflow-y: auto;
}

	/* 弹窗样式 - 将滚动条设置在弹窗body层，宽度自适应 */
.qa-modal ::v-deep .ant-modal {
	width: auto !important;
	max-width: 80vw;
}

.qa-modal ::v-deep .ant-modal-content {
	background-color: #fff;
	width: auto;
}

.qa-modal ::v-deep .ant-modal-body {
	max-height: calc(100vh - 110px);
	overflow-y: auto;
	padding: 24px;
	width: auto;
	position: relative;
}

</style>